import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = import.meta.env?.VITE_GA_MEASUREMENT_ID;

export function useGoogleAnalytics() {
  const location = useLocation();

  // Load GA script once
  useEffect(() => {
    if (!GA_ID || GA_ID === 'your-google-analytics-id-here') return;
    if (window.__gaLoaded) return;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    script.async = true;
    document.head?.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args) { window.dataLayer?.push(args); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID, { send_page_view: false });
    window.__gaLoaded = true;
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (!GA_ID || GA_ID === 'your-google-analytics-id-here') return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
      page_path: location?.pathname + location?.search,
      page_title: document.title,
    });
  }, [location]);
}
